import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import DateRangeSelect from '../DateRangeSelect/DateRangeSelect';
import MultiSelect from '../MultiSelect/MultiSelect';
import {
    getProductSelectValues,
    getSourceSelectValues,
    getPageSelectValues,
} from '../../../utils/formUtils';
import ButtonSubmit from '../ButtonSubmit/ButtonSubmit';
import ButtonClear from '../ButtonClear/ButtonClear';
import ButtonSwitch from '../ButtonSwitch/ButtonSwitch';
import translationPropType from '../../../proptypes/translationPropType';
import genericFormStatePropTypes from '../../../proptypes/genericFormStatePropTypes';

const GenericStatsForm = ({
    handleClear,
    handleSubmit,
    handleUpdateFormField,
    userLocale,
    searchActive,
    formState,
    translation,
}) => {
    const setField = (field, value) => {
        handleUpdateFormField({ [field]: value });
    };

    const handleCheckEvent = (event) => {
        setField([event.target.name], event.target.checked);
    };

    const handleMultiSelectEvent = name => (dataArray) => {
        setField(name, dataArray.map(data => data.id));
    };

    const submit = (event) => {
        event.preventDefault();
        handleSubmit({ ...formState });
    };

    const productSelectValues = getProductSelectValues(translation);
    const selectedProducts = productSelectValues
        .filter(product => formState.product.includes(product.id));

    const sourceSelectValues = getSourceSelectValues(translation);
    const selectedSources = sourceSelectValues
        .filter(source => formState.source.includes(source.id));

    const pageSelectValues = getPageSelectValues(translation);
    const selectedPages = pageSelectValues
        .filter(page => formState.page.includes(page.id));

    return (
        <form onSubmit={submit} autoComplete="off">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <MultiSelect
                        allValues={productSelectValues}
                        selectedValues={selectedProducts}
                        label={translation.PRODUCTS}
                        placeholder={translation.ALL}
                        handleSelect={handleMultiSelectEvent('product')}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DateRangeSelect
                        to={formState.to}
                        locale={userLocale}
                        from={formState.from}
                        setValue={setField}
                        translation={translation}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <MultiSelect
                        allValues={sourceSelectValues}
                        selectedValues={selectedSources}
                        label={translation.SOURCES}
                        placeholder={translation.ALL}
                        handleSelect={handleMultiSelectEvent('source')}
                        fullWidth
                        translation={translation}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <MultiSelect
                        allValues={pageSelectValues}
                        selectedValues={selectedPages}
                        label={translation.PAGES}
                        placeholder={translation.ALL}
                        handleSelect={handleMultiSelectEvent('page')}
                        fullWidth
                        translation={translation}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ButtonSwitch
                        checked={formState.isCustomer}
                        label={translation.ONLY_CUSTOMERS}
                        name="isCustomer"
                        onChange={handleCheckEvent}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ButtonSubmit
                        title={translation.SEARCH}
                    />
                    <ButtonClear
                        disabled={!searchActive}
                        onClick={handleClear}
                        title={translation.CLEAR}
                    />
                </Grid>
            </Grid>
        </form>
    );
};

GenericStatsForm.propTypes = {
    translation: translationPropType.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleUpdateFormField: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired,
    searchActive: PropTypes.bool.isRequired,
    userLocale: PropTypes.string.isRequired,
    formState: genericFormStatePropTypes.isRequired,
};

export default GenericStatsForm;
